import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditDepartment = ({ show, onClose, refresh, data }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [subDeptName, setSubDeptName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (data) {
            setSubDeptName(data.level_name);
            setDescription(data.description);
        }
    }, [data]);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [data_name, setData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/level/getall`)
            .then(response => {
                setData(response.data.filter(item => item.sno !== data.sno).map(mode => mode.level_name.toLowerCase()));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;

        if (!subDeptName.trim()) {
            newErrors.name = "This Field is Required.";
        } else if (!regex.test(subDeptName)) {
            newErrors.name = "Not a Valid Name";
        } else if (data_name.includes(subDeptName.trim().toLowerCase())) {
            newErrors.name = "This Name Already Exists";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            level_name: subDeptName,
            description: description
        };

        axios.put(`${baseURL}/level/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Level Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Level Creation Failed");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Department</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Level"
                                maxLength={100}
                                value={subDeptName}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setSubDeptName(formatName(onlyAlphabets));
                                }}
                            />
                            {errors.name && (<div className="text-danger">{errors.name}</div>)}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className="form-control h-auto" name="comment" placeholder="Description"
                                maxLength={250}
                                value={description}
                                onChange={(e) => setDescription(formatName(e.target.value))}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Level
                            <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditDepartment;
